import React, { useEffect } from "react";

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-2xl font-bold mb-4">ÇEREZ AYDINLATMA METNİ</h1>
      <p className="mb-4">
        Bu metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu’nun (“KVKK”)
        10. maddesi ile Aydınlatma Yükümlülüğünün Yerine Getirilmesinde Uyulacak
        Usul ve Esaslar Hakkında Tebliğ kapsamında veri sorumlusu sıfatıyla
        SETSİS BİLİŞİM TEKNOLOJİLERİ SANAYİ VE TİCARET ANONİM ŞİRKETİ (“Şirket”)
        tarafından hazırlanmıştır. Bu Çerez Aydınlatma Metni’nin amacı, internet
        sitemizde kullanılan çerezlerin cihazınıza yerleştirilmesi aracılığıyla
        otomatik yolla elde edilen kişisel verilerin işlenmesine ilişkin olarak,
        hangi amaçlarla hangi tür çerezleri kullandığımız, hukuki sebebi ve
        haklarınız hakkında sizlere bilgi vermektir.
      </p>

      <h2 className="text-xl font-semibold mb-3">ÇEREZ (“COOKIE”) NEDİR?</h2>
      <p className="mb-4">
        Çerezler, ziyaret ettiğiniz internet siteleri/uygulamalar tarafından
        tarayıcılar aracılığıyla bilgisayarınıza (ya da akıllı telefon veya
        tablet gibi diğer cihazlarınıza) kaydedilen ve genelde harf ve
        rakamlardan oluşan çok küçük metin dosyalarıdır. Çerezler, ziyaretçilere
        ilişkin isim, cinsiyet veya adres gibi kişisel verileri içermezler.
      </p>

      <h2 className="text-xl font-semibold mb-3">
        VERİ SORUMLUSU ÇEREZLERİ NASIL KULLANMAKTADIR?
      </h2>
      <ul className="list-disc ml-6 mb-4">
        <li>
          İnternet sitesinin çalışması için gerekli temel fonksiyonları
          gerçekleştirmek,
        </li>
        <li>
          İnternet sitesini analiz etmek ve İnternet sitesinin performansını
          arttırmak. Örneğin, İnternet sitesini ziyaret edenlerin sayısının
          tespit edilmesi ve buna göre performans ayarlarının yapılması ya da
          ziyaretçilerin aradıklarını bulmalarının kolaylaştırılması,
        </li>
        <li>
          İnternet sitesinin işlevselliğini arttırmak ve kullanım kolaylığı
          sağlamak. Örneğin, internet sitesini ziyaret eden ziyaretçinin daha
          sonraki ziyaretinde kullanıcı adı bilgisinin ya da arama sorgularının
          hatırlanması veya internet sitesi üzerinden üçüncü taraf sosyal medya
          faaliyetlerine bağlantı sağlamak,
        </li>
        <li>
          Kişiselleştirme, hedefleme ve reklamcılık faaliyeti gerçekleştirmek.
          Örneğin, ziyaretçilerin görüntüledikleri sayfa ve ürünler üzerinden
          ziyaretçilerin ilgi alanlarıyla ilgili reklam gösterilmesi,
        </li>
      </ul>

      <h2 className="text-xl font-semibold mb-3">ÇEREZ YÖNETİMİ</h2>
      <p className="mb-4">
        İnternet tarayıcınızın çeşidine göre aşağıdaki adımları izleyerek,
        çerezler hakkında bilgi edinip, izin verme veya reddetme hakkınızı
        kullanabilirsiniz:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>
          <strong>Google Chrome:</strong> Browser’ınızın “adres bölümünde” yer
          alan, “iki çizgi” işaretine tıklayarak, “Cookie” sekmesinden çerezlere
          izin verebilir veya bloke edebilirsiniz.
        </li>
        <li>
          <strong>İnternet Explorer (Microsoft Edge):</strong> Browser’ınızın
          sol üst köşesinde yer alan “Kilit” işaretinden veya sağ üstte yer alan
          “Ayarlar” Bölümünden “Gizlilik, arama ve hizmetler” sekmesini tıklayın
          ve “izin ver” veya “izin verme” şeklinde çerez yönetimizi
          gerçekleştirebilirsiniz.
        </li>
        <li>
          <strong>Mozilla Firefox:</strong> Browser’ınızın sağ üst köşesinde yer
          alan “menüyü aç” sekmesini tıklayınız. “Seçenekler” görselini
          tıklayarak “Gizlilik ve Güvenlik” butonunu kullanarak çerez
          yönetiminizi yapabilirsiniz.
        </li>
        <li>
          <strong>Safari:</strong> Telefonunuzun “Ayarlar” bölümünden “safari”
          sekmesini seçip, “Gizlilik ve Güvenlik” Bölümünden “Siteler Arası
          Takibi Engelle” seçeneğini aktif hale getirerek tüm çerez yönetiminizi
          sağlayabilirsiniz.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mb-3">ÇEREZ ÇEŞİTLERİ</h2>
      <ul className="list-disc ml-6 mb-4">
        <li>
          <strong>Kullanım süresine göre çerez çeşitleri:</strong> Oturum
          çerezleri ve kalıcı çerezler kullanılmaktadır. Oturum çerezi,
          tarayıcınızı kapattığınızda sona erer. Kalıcı çerez ise sabit
          diskinizde uzun bir süre veya süresiz olarak kalır.
        </li>
        <li>
          <strong>
            Çerezin sahibi veya çerezi yerleştiren tarafa göre çerez çeşitleri:
          </strong>{" "}
          “Veri Sorumlusu’na ait çerezler” ve “üçüncü taraf çerezler”
          kullanılmaktadır.
        </li>
        <li>
          <strong>Kullanım amaçlarına göre çerez çeşitleri:</strong> Teknik
          çerezler, hedefleme/reklam çerezleri, kişiselleştirme çerezleri ve
          analitik çerezler kullanılmaktadır.
        </li>
      </ul>

      <h2 className="text-xl font-semibold mb-3">
        İlgili Kişi Olarak KVKK Kapsamındaki Haklarınız
      </h2>
      <p className="mb-4">
        KVKK’nın ilgili kişinin haklarını düzenleyen 11. maddesi kapsamındaki
        taleplerinizi Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında
        Tebliğ’e göre aşağıdaki adreslere iletebilirsiniz:
      </p>
      <ul className="list-disc ml-6 mb-4">
        <li>
          Adres: Kaptanpaşa Mahallesi Halit Ziya Türkkan Sokak Famas Plaza
          C-Blok No:19/3 Şişli
        </li>
        <li>E-posta: kvkk@lensa.com.tr</li>
        <li>KEP: lensa.bilisim@hs01.kep.tr</li>
      </ul>
    </div>
  );
};

export default CookiePolicy;
